(function () {
  function getDrawer() {
    return document.querySelector('#CartDrawer');
  }

  function getCheckoutButton(drawer) {
    return drawer ? drawer.querySelector('#CartDrawer-Checkout') : null;
  }

  function getCompatibilityWrapper(drawer) {
    return drawer ? drawer.querySelector('[data-cart-drawer-compatibility]') : null;
  }

  function requiresConfirmation(wrapper) {
    return wrapper && wrapper.dataset.requiresConfirmation === 'true';
  }

  function getScrollContainer(element) {
    return element ? element.closest('cart-drawer-items') : null;
  }

  function restoreScrollAfterLayout(scrollContainer, scrollTop) {
    if (!scrollContainer) return;

    requestAnimationFrame(function () {
      scrollContainer.scrollTop = scrollTop;
      requestAnimationFrame(function () {
        scrollContainer.scrollTop = scrollTop;
      });
    });
  }

  function getCompatibilityCheckboxes(drawer) {
    return drawer ? drawer.querySelectorAll('[data-compatibility-confirm]') : [];
  }

  function updateCheckoutState() {
    const drawer = getDrawer();
    const checkoutButton = getCheckoutButton(drawer);
    const wrapper = getCompatibilityWrapper(drawer);
    const cartDrawer = document.querySelector('cart-drawer');

    if (!checkoutButton) return;

    if (cartDrawer?.classList.contains('is-empty') || checkoutButton.hasAttribute('data-cart-empty')) {
      checkoutButton.disabled = true;
      checkoutButton.classList.remove('cart-drawer__checkout--gated');
      return;
    }

    if (!wrapper || !requiresConfirmation(wrapper)) {
      checkoutButton.disabled = false;
      checkoutButton.classList.remove('cart-drawer__checkout--gated');
      return;
    }

    const checkboxes = getCompatibilityCheckboxes(drawer);
    const allChecked = checkboxes.length > 0 && Array.from(checkboxes).every((checkbox) => checkbox.checked);

    checkoutButton.disabled = !allChecked;
    checkoutButton.classList.toggle('cart-drawer__checkout--gated', !allChecked);
  }

  function initCompatibilityGate() {
    updateCheckoutState();
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      const summary = event.target.closest('.cart-drawer__compatibility-details-toggle');
      if (!summary) return;

      const details = summary.closest('details');
      const scrollContainer = getScrollContainer(summary);
      if (!details || !scrollContainer) return;

      const scrollTop = scrollContainer.scrollTop;

      details.addEventListener(
        'toggle',
        function onToggle() {
          details.removeEventListener('toggle', onToggle);
          restoreScrollAfterLayout(scrollContainer, scrollTop);
        },
        { once: true }
      );
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      const label = event.target.closest('.cart-drawer__compatibility-confirm');
      if (!label) return;

      const checkbox = label.querySelector('[data-compatibility-confirm]');
      const scrollContainer = getScrollContainer(label);
      if (!checkbox || !scrollContainer) return;

      const scrollTop = scrollContainer.scrollTop;

      checkbox.addEventListener(
        'change',
        function onChange() {
          checkbox.removeEventListener('change', onChange);
          restoreScrollAfterLayout(scrollContainer, scrollTop);
        },
        { once: true }
      );
    },
    true
  );

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-compatibility-confirm]')) return;
    updateCheckoutState();
  });

  document.addEventListener('DOMContentLoaded', initCompatibilityGate);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      requestAnimationFrame(initCompatibilityGate);
    });
  }

  document.addEventListener('cart:updated', function () {
    requestAnimationFrame(initCompatibilityGate);
  });

  window.initCartDrawerKeyboardCompatibility = initCompatibilityGate;
})();
